import type { Messages } from '../catalogue.en'

export const tracker: Partial<Messages> = {
  'tracker.trigger': 'דיווח על נושא',
  'tracker.dialogTitle': 'הוספת נושא',
  'tracker.foldWindow': 'קיפול חלון הדיווח',
  'tracker.unfoldWindow': 'פתיחת חלון הדיווח',
  'tracker.moveWindow': 'הזזת חלון הדיווח',
  'tracker.description': 'תיאור',
  'tracker.charactersLeft': 'נותרו {count}',
  'tracker.context': 'נשלח עם הדיווח באופן אוטומטי.',
  'tracker.module': 'מודול',
  'tracker.screen': 'מסך',
  'tracker.agent': 'הקצאה לסוכן',
  'tracker.agentsLoading': 'טוען זמינות סוכנים…',
  'tracker.agentsUnavailable': 'זמינות הסוכנים אינה זמינה. עדיין ניתן ליצור את הנושא.',
  'tracker.agentFree': 'פנוי',
  'tracker.agentBusy': 'עסוק',
  'tracker.agentOffline': 'לא מחובר',
  'tracker.agentModel': 'מודל: {model}',
  'tracker.agentCurrentWork': 'עבודה נוכחית: {summary}',
  'tracker.attachments': 'קבצים מצורפים',
  'tracker.optional': 'רשות',
  'tracker.chooseAttachments': 'בחירת קבצים מצורפים',
  'tracker.attachmentCountOne': 'קובץ מצורף אחד',
  'tracker.attachmentCountMany': '{count} קבצים מצורפים',
  'tracker.attachmentNumber': '{number}.',
  'tracker.attachmentOn': 'נוסף במסך {screen}',
  'tracker.removeAttachment': 'הסרת קובץ מצורף {number}',
  'tracker.attachmentLimit': 'אפשר לצרף עד {count} קבצים נתמכים לנושא אחד.',
  'tracker.unsavedIntent': 'דיווח תקלה \u2014 טרם נשלח',
  'tracker.openIssues': 'פתיחת הנושאים',
  'tracker.opening': 'פותח נושאים',
  'tracker.popupBlocked': 'לא ניתן לפתוח את מערכת הנושאים בלשונית חדשה.',
  'tracker.cancel': 'ביטול',
  'tracker.submit': 'יצירת נושא',
  'tracker.submitting': 'יוצר נושא',
  'tracker.created': 'נושא #{number} נוצר.',
  'tracker.createdDetail': 'הפנייה נשמרה במערכת המעקב.',
  'tracker.assignedAgent': 'נשלח אל {agent}.',
  'tracker.reportAnother': 'דיווח נוסף',
  'tracker.close': 'סגירה',
  'tracker.attachmentWarning': 'הנושא נוצר, אך לא ניתן היה להעלות קובץ מצורף.',
  'tracker.releaseCheckWarning': 'דיווח ההמשך נוצר, אבל לא ניתן היה לסמן את משימת הגרסה כבדוקה. נסו שוב «סימון כנבדקה» בלשונית «גרסה».',
  'tracker.dispatchWarning': 'הנושא נוצר, אך ההקצאה לסוכן לא נמסרה.',
  'tracker.errorTooLarge': 'הקבצים המצורפים גדולים מדי יחד.',
  'tracker.errorUnsupported': 'יש להשתמש בקובצי PNG, JPEG, WebP, PDF, JSON, Markdown או טקסט פשוט.',
  'tracker.errorForbidden': 'החשבון שלך אינו מורשה ליצור נושאים.',
  'tracker.errorSignedOut': 'תוקף ההתחברות פג. יש להיכנס שוב ואז לשלוח את הדיווח.',
  'tracker.errorRefused': 'הדיווח נדחה כפי שנכתב. יש לערוך אותו ולנסות שוב.',
  'tracker.errorUnavailable': 'לא ניתן לאשר שהפנייה נוצרה. הדיווח עדיין כאן. נסו שוב כדי לבדוק או לשלוח אותו.',
  'tracker.errorChanged': 'ניסיון קודם כבר יצר דיווח עם תוכן שונה. בדקו את «הדיווחים שלי» לפני שליחה חוזרת.',
  'tracker.myReports': 'הדיווחים שלי',
  'tracker.openReport': 'פתיחת דיווח #{number}',
  'tracker.tabs': 'חלקי חלון הדיווח',
  'tracker.tabReport': 'דיווח',
  'tracker.tabRelease': 'גרסה',
  'tracker.release.title': 'בדיקת גרסה',
  'tracker.release.subtitle': 'משימות סגורות במעקב שעדיין מחכות לבדיקה ידנית.',
  'tracker.release.includeChecked': 'להציג משימות שנבדקו',
  'tracker.release.loading': 'טוען משימות גרסה',
  'tracker.release.empty': 'אין משימות שמחכות לבדיקת גרסה',
  'tracker.release.emptyDetail': 'משימות סגורות עם release/checked מוסתרות כברירת מחדל.',
  'tracker.release.listLabel': 'משימות לבדיקת גרסה',
  'tracker.release.noRelease': 'אין תווית גרסה',
  'tracker.release.checkedState': 'נבדקה',
  'tracker.release.check': 'סימון כנבדקה',
  'tracker.release.checking': 'מסמן כנבדקה',
  'tracker.release.fix': 'תיקון',
  'tracker.release.followUpFor': 'דיווח המשך',
  'tracker.release.followUpDraft': 'דיווח המשך למשימה סגורה #{number}: {title}',
  'tracker.release.errorChanged': 'המשימה השתנתה במעקב. טענו מחדש את לשונית הגרסה ונסו שוב.',
  'tracker.release.errorNotClosed': 'אפשר לסמן כנבדקות רק משימות סגורות.',
  'tracker.release.errorGone': 'המשימה הזו כבר אינה ברשימת בדיקת הגרסה.',

  'tracker.reports.title': 'דיווחים',
  'tracker.reports.subtitle': 'דיווחי תקלות שנשלחו מהיישום הזה.',
  'tracker.reports.tableLabel': 'רשימת הדיווחים',
  'tracker.reports.scopeLabel': 'היקף',
  'tracker.reports.scopeMine': 'הדיווחים שלי',
  'tracker.reports.scopeAll': 'כל הדיווחים',
  'tracker.reports.loading': 'טוען דיווחים',
  'tracker.reports.loadFailed': 'לא ניתן היה לטעון את הדיווחים.',
  'tracker.reports.forbidden': 'החשבון שלכם אינו יכול לפתוח דיווחים.',
  'tracker.reports.empty': 'אין דיווחים עדיין',
  'tracker.reports.emptyDetail': 'דיווחים שנשלחו מהיישום הזה יופיעו כאן.',
  'tracker.reports.columnNumber': 'מספר',
  'tracker.reports.columnTitle': 'כותרת',
  'tracker.reports.columnReporter': 'מדווח/ת',
  'tracker.reports.columnEnvironment': 'סביבה',
  'tracker.reports.columnState': 'מצב',
  'tracker.reports.columnWork': 'עבודה',
  'tracker.reports.columnCreated': 'נוצר',
  'tracker.reports.columnUpdated': 'עודכן',
  'tracker.reports.columnActions': 'פעולות',
  'tracker.reports.openNamed': 'פתיחת דיווח #{number}',
  'tracker.reports.deleteNamed': 'מחיקת דיווח #{number}',
  'tracker.reports.reload': 'רענון הרשימה',
  'tracker.reports.reloaded': 'הרשימה רועננה.',
  'tracker.reports.reloadFailed': 'לא ניתן היה לרענן את הרשימה.',

  'tracker.report.title': 'דיווח',
  'tracker.report.number': '#{number}',
  'tracker.report.back': 'חזרה לדיווחים',
  'tracker.report.loading': 'טוען דיווח',
  'tracker.report.loadFailed': 'לא ניתן היה לטעון את הדיווח.',
  'tracker.report.notFound': 'הדיווח הזה אינו קיים או שנמחק.',
  'tracker.report.forbidden': 'החשבון שלכם אינו יכול לפתוח את הדיווח הזה.',
  'tracker.report.state': 'מצב',
  'tracker.report.stateOpen': 'פתוח',
  'tracker.report.stateClosed': 'סגור',
  'tracker.report.work': 'עבודה',
  'tracker.report.started': 'נלקח לטיפול',
  'tracker.report.notStarted': 'טרם התחיל',
  'tracker.report.reporter': 'מדווח/ת',
  'tracker.report.environment': 'סביבה',
  'tracker.report.created': 'נוצר',
  'tracker.report.updated': 'עודכן',
  'tracker.report.readOnlyNote': 'לא ניתן עוד לשנות את הדיווח הזה מהחשבון שלכם.',
  'tracker.report.readOnlyComments': 'עדיין אפשר להוסיף תגובות.',
  'tracker.report.description': 'תיאור',
  'tracker.report.noDescription': 'ללא תיאור.',
  'tracker.report.attachments': 'קבצים מצורפים לדיווח',
  'tracker.report.attachmentWarning': 'השינוי נשמר, אך לא ניתן היה להעלות קובץ מצורף.',
  'tracker.report.comments': 'תגובות',
  'tracker.report.noComments': 'אין תגובות עדיין.',
  'tracker.report.commentEdited': 'נערכה',
  'tracker.report.commentAttachments': 'קבצים מצורפים לתגובה',
  'tracker.report.commentLabel': 'תגובה חדשה',
  'tracker.report.commentHint': 'Markdown. תמונה שמודבקת בשדה מצורפת לתגובה.',
  'tracker.report.commentReadOnly': 'לא ניתן עוד להוסיף תגובות לדיווח הזה. הטיוטה שלכם עדיין כאן.',
  'tracker.report.send': 'הוספת תגובה',
  'tracker.report.sending': 'מוסיף תגובה',
  'tracker.report.commentAdded': 'התגובה נוספה.',
  'tracker.report.editDescription': 'עריכת התיאור',
  'tracker.report.editTitle': 'עריכת הכותרת',
  'tracker.report.titleField': 'כותרת',
  'tracker.report.saveTitle': 'שמירת הכותרת',
  'tracker.report.savingTitle': 'שומר את הכותרת',
  'tracker.report.titleSaved': 'הכותרת נשמרה.',
  'tracker.report.cancelTitle': 'ביטול עריכת הכותרת',
  'tracker.report.save': 'שמירת השינויים',
  'tracker.report.saving': 'שומר',
  'tracker.report.saved': 'השינויים נשמרו.',
  'tracker.report.close': 'סגירת הדיווח',
  'tracker.report.closing': 'סוגר',
  'tracker.report.closeTitle': 'לסגור את דיווח #{number}?',
  'tracker.report.closeDescription': 'דיווח סגור נשאר קריא ופתוח לתגובות, אך לא ניתן עוד לערוך אותו כאן.',
  'tracker.report.closeConfirm': 'סגירת הדיווח',
  'tracker.report.closed': 'הדיווח נסגר.',
  'tracker.report.delete': 'מחיקת הדיווח',
  'tracker.report.deleting': 'מוחק',
  'tracker.report.deleteTitle': 'למחוק את דיווח #{number}?',
  'tracker.report.deleteDescription': 'הדיווח והתגובות שלו יוסרו ממערכת המעקב. לא ניתן לבטל פעולה זו.',
  'tracker.report.deleteConfirm': 'מחיקה',
  'tracker.report.deleted': 'דיווח #{number} נמחק.',
  'tracker.report.reload': 'טעינה מחדש של הדיווח',
  'tracker.report.reloaded': 'הדיווח נטען מחדש. עברו עליו ונסו שוב.',
  'tracker.report.reloadFailed': 'לא ניתן היה לטעון מחדש את הדיווח.',
  'tracker.report.unsavedTitle': 'כותרת הדיווח \u2014 טרם נשמרה',
  'tracker.report.unsavedDescription': 'תיאור הדיווח \u2014 טרם נשמר',
  'tracker.report.unsavedComment': 'תגובה \u2014 טרם נוספה',
  'tracker.report.errorChanged': 'הדיווח השתנה מאז שנטען. טענו אותו מחדש ונסו שוב.',
  'tracker.report.errorReadOnly': 'הדיווח נלקח לטיפול ולא ניתן עוד לשנות אותו כאן.',
  'tracker.report.errorUncertain': 'לא ניתן היה לאשר את השינוי. הטיוטה שלכם עדיין כאן. נסו שוב כדי לבדוק או לשלוח אותה.',
  'tracker.report.errorUnavailable': 'מערכת המעקב אינה זמינה כרגע. הטיוטה שלכם עדיין כאן. נסו שוב מאוחר יותר.',
  'tracker.report.errorForbidden': 'החשבון שלכם אינו יכול לשנות את הדיווח הזה.',
  'tracker.report.errorGone': 'הדיווח הזה כבר אינו קיים.',
  'tracker.report.errorRefused': 'השינוי נדחה כפי שנכתב. ערכו אותו ונסו שוב.',

  'tracker.editor.tabs': 'תצוגת העורך',
  'tracker.editor.write': 'כתיבה',
  'tracker.editor.preview': 'תצוגה מקדימה',
  'tracker.editor.toolbar': 'עיצוב',
  'tracker.editor.heading': 'כותרת',
  'tracker.editor.bold': 'מודגש',
  'tracker.editor.italic': 'נטוי',
  'tracker.editor.strikethrough': 'קו חוצה',
  'tracker.editor.quote': 'ציטוט',
  'tracker.editor.code': 'קוד',
  'tracker.editor.link': 'קישור',
  'tracker.editor.bulletedList': 'רשימת תבליטים',
  'tracker.editor.numberedList': 'רשימה ממוספרת',
  'tracker.editor.taskList': 'רשימת משימות',
  'tracker.editor.nothingToPreview': 'אין עדיין מה להציג.',
}
